module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-index-box column"
  }, [_c('div', {
    staticClass: "waiting-room-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("招待されたルーム")])]), _vm._v(" "), _c('div', {
    staticClass: "title",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("招待されたルームが表示されない場合は、招待リンクから再度ご参加ください。")])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-room-info-box column"
  }, _vm._l((_vm.lists), function(item, index) {
    return _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title-box column"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.roomName))]), _vm._v(" "), _c('div', {
      staticClass: "label row m-column"
    }, [_c('div', [_c('span', {
      staticClass: "iconfont icon-shijian"
    }), _vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "iconfont icon-01"
    }), _vm._v(_vm._s(item.homeownerName))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns-box row row-right"
    }, [_c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.toRoom(item.id, item.isHomeownerFlag)
        }
      }
    }, [_vm._v("詳細を見る")])], 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86317dfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/room/Index.vue
// module id = 896
// module chunks = 1